import { createContext } from "react";
import { IFormContextValue, IFormState } from "./formInterfaces";

const FormContext = createContext<IFormContextValue>({
  subscribe: (_: any) => {},
  dispatch: (_: any) => {},
  subscribeFormAction: (_: any) => {},
  updateFormValues: (_: any) => {},
  updateFormState: (_: any) => {},
  getFormValues: () => ({}),
  getFormState: () => ({} as IFormState)
});

const { Provider, Consumer } = FormContext;

export { Provider as FormProvider, Consumer as FormConsumer, FormContext };
